import React, { useState } from "react";
import { Link } from "react-router-dom";
import { productData } from "././ProductData";
import LazyLoad from "react-lazyload";
import "./Products.css";

function ProductList() {
  const [data, setData] = useState(productData);
  const filterResult = (catItem) => {
    const result = productData.filter((curData) => {
      return curData.category === catItem;
    });
    setData(result);
  };
  return (
    <>
      <div className="categories">
        <button className="ProBtnPan" onClick={() => setData(productData)}>
          All
        </button>
        <button className="ProBtnPan" onClick={() => filterResult("Archies")}>
          Archies
        </button>
        <button className="ProBtnPan" onClick={() => filterResult("Balloons")}>
          Balloons
        </button>
        <button className="ProBtnPan" onClick={() => filterResult("Costumes")}>
          Costumes
        </button>
        <button className="ProBtnPan" onClick={() => filterResult("Danglers")}>
          Danglers
        </button>
        <button
          className="ProBtnPan"
          onClick={() => filterResult("InflatableBounce")}
        >
          Inflatable Bounce
        </button>
        <button className="ProBtnPan" onClick={() => filterResult("Tent")}>
          Tent
        </button>

        <button
          className="ProBtnPan"
          onClick={() => filterResult("Inflatables")}
        >
          Inflatables
        </button>
        <button
          className="ProBtnPan"
          onClick={() => filterResult("Water Roller")}
        >
          Water Roller
        </button>
      </div>
      <ul className="productList">
        {data.map((product) => (
          <li key={product.id} className="productCard">
            <Link to={`/product/${product.id}`}>
              <LazyLoad height={200} offset={100} className="picPan">
                <img
                  className="productImg"
                  src={product.img}
                  alt={product.name}
                />
              </LazyLoad>
              <div className="textPan">
                <div className="proName">{product.name}</div>
                <div>see more</div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
export default ProductList;
